var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterofcredit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.19 14H19.81C16.17 14 14 16.17 14 19.81V28.18C14 31.83 16.17 34 19.81 34H28.18C31.82 34 33.99 31.83 33.99 28.19V19.81C34 16.17 31.83 14 28.19 14ZM27.75 27.75H20.25C19.84 27.75 19.5 27.41 19.5 27C19.5 26.59 19.84 26.25 20.25 26.25H27.75C28.16 26.25 28.5 26.59 28.5 27C28.5 27.41 28.16 27.75 27.75 27.75ZM27.75 21.75H20.25C19.84 21.75 19.5 21.41 19.5 21C19.5 20.59 19.84 20.25 20.25 20.25H27.75C28.16 20.25 28.5 20.59 28.5 21C28.5 21.41 28.16 21.75 27.75 21.75Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterofcredit2);
export default __webpack_public_path__ + "static/media/letterofcredit2.23ec1926880d5f8380701700fb56ab15.svg";
export { ForwardRef as ReactComponent };